import React, { Component } from 'react';
import { Row, Col, Spinner, H1, Button, Translate, Image, Card, Input, Form, Icon, MediaPlayer } from '$common';
import CSSModules from 'react-css-modules';
import style from './gallery.scss';
import Lightbox from 'react-images';
import moment from 'moment';
import { getSubmission } from '../../../api';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import { convertLocation } from '$lib/normalize';
import AnswerList from '../../submissions/show/answer-list';
import { browserHistory } from 'react-router';
import GalleryReport from './gallery-report';

let IMAGES = [];

const Map = withScriptjs(withGoogleMap(props =>
  <GoogleMap
    defaultZoom={14}
    defaultCenter={convertLocation(props.submission.location)}
  >
    {props.submission.other_submissions ? (props.submission.other_submissions.map((submission, index) => (
      <Marker
        icon={require(`$shared/images/markers/withdrawn.png`)}
        position={convertLocation(submission.location)}
        zIndex={index}
        key={submission.id}
      />
    ))) : null}
    <Marker
      icon={require(`$shared/images/markers/accepted.png`)}
      position={convertLocation(props.submission.location)}
      zIndex={999}
    />
  </GoogleMap>
));

@CSSModules(style, { allowMultiple: true })
export default class List extends Component {

  state = {
    gallery: this.props.gallery,
    currentImage: 0,
    lightboxIsOpen: false,
    images: []
  };

  componentWillMount() {
    this.loadImages();
    // window.Intercom('trackEvent', 'OPENED_GALLERY');
  }

  makeImageResizeURL(url, size) {
    if (process.target[0] === "production") {
      if (url.search('bounty-app') !== -1) {
        return url.replace('bounty-app.s3.amazonaws.com', `images2.twentify.com/${size}`);
      } else {
        return url.replace('celebi.s3.eu-central-1.amazonaws.com', `images.twentify.com/${size}`);
      }
    } else {
      return url;
    }
  }

  pushImages(item, caption) {
    IMAGES.push({
      src: item.link,
      thumbnail: this.makeImageResizeURL(item.link, '70x70'),
      caption: caption,
      question_type: item.question_type,
      submission_id: item.submission_id
    });
  }

  loadImages() {
    const { gallery, projectId } = this.props;
    let imageIndex = 0;
    IMAGES = [];

    if (projectId) {
      gallery.media.items.map( item => {
        this.pushImages(item, gallery.project_name);
        item.index = imageIndex;
        imageIndex++;
      })
    } else {
      gallery.map( project => {
        project.media.items.map( item => {
          this.pushImages(item, gallery.project_name);
          item.index = imageIndex;
          imageIndex++;
        })
      })
    }

    this.setState({ images: IMAGES });
  }

  handleSearch(values) {
    this.props.onFilterChange('task_title_cont', values.task_title_cont);
  }

  loadSubmission(id) {
    this.setState({ submission: undefined });
    getSubmission(this.state.images[id].submission_id).then(submission => {
      this.setState({
        submission: submission.data
      });
    });
  }

  openLightbox(index, event) {
    this.loadImages();
    const delay = 200;
    setTimeout(() => {
      if (typeof index !== "undefined") {
        this.loadSubmission(index);
        this.setState({
          currentImage: index,
          lightboxIsOpen: true,
          customMedia: this.state.images[index].question_type === 'video_capture' ? this.customMedia(index) : null
        });
      }
    }, delay);
    event.preventDefault();
  }

  closeLightbox(e) {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
      submission: undefined,
      customMedia: null
    });
  }

  gotoPrevious() {
    this.loadSubmission(this.state.currentImage - 1);
    this.setState({
     currentImage: this.state.currentImage - 1,
     customMedia: this.state.images[this.state.currentImage - 1].question_type === 'video_capture' ? this.customMedia(this.state.currentImage - 1) : null
    });
  }

  gotoNext() {
    this.loadSubmission(this.state.currentImage + 1);
    this.setState({
      currentImage: this.state.currentImage + 1,
      customMedia: this.state.images[this.state.currentImage + 1].question_type === 'video_capture' ? this.customMedia(this.state.currentImage + 1) : null
    });
  }

  gotoImage(index) {
    this.loadSubmission(index);
    this.setState({
      currentImage: index,
      customMedia: this.state.images[index].question_type === 'video_capture' ? this.customMedia(index) : null
    });
  }

  customMedia(index) {
    return(
      <MediaPlayer
        url={this.state.images[index].src}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      />
    )
  }

  renderCaption(id) {
    const { submission } = this.state;

    return(
      <div styleName="caption">
        {
          typeof submission !== "undefined" ?
            <div>
              <h2>{submission.task.title}</h2>
              <h3>
                <b>{submission.total_answer_points}</b>
                <span>{Translate.get('score')}</span>
              </h3>
              <p>{Translate.get('submitted_at')}: {moment(submission.submitted_at , 'YYYY-MM-DDTh:mm:ssZ').fromNow()}</p>
              <p>{Translate.get('address')}: {submission.task.address}</p>

              <Map
                submission={submission}
                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env[0].GOOGLE_KEY}&v=3.exp&libraries=drawing,visualization`}
                loadingElement={
                  <div style={{ height: `200px` }} />
                }
                containerElement={
                  <div style={{ height: `200px` }} />
                }
                mapElement={
                  <div style={{ height: `200px` }} />
                }
              />
              
              <h2 styleName="tasks-title">{Translate.get('tasks')}</h2>

              <AnswerList
                questions={submission.task.task_form.questions}
                answers={submission.answers}
                inLightbox={true}
              />
            </div>
          : <Spinner block center />
        }
      </div>
    )
  }

  render() {
    const { gallery, totalCount, currentPage, isFetching, keepPreviousData, loadGallery, loadProjectGallery, projectId, loadMore, getProjects, getProject, createGalleryReport } = this.props;

    return (
      <div styleName="root">
        <div styleName="page-header">
          {Translate.get('gallery')}
        </div>
        <Row>
          <Col md="5/6">
            <div styleName="search">
              <Form onSubmit={::this.handleSearch}>
                <Input name="task_title_cont" placeholder={Translate.get('search_by_task_title')} forceOnChange />
                <Icon name="search" />
              </Form>
            </div>
          </Col>
          <Col md="1/6">
            <GalleryReport
              getProjects={getProjects}
              getProject={getProject}
              createReport={createGalleryReport}
            />
          </Col>
        </Row>
        {
          isFetching && !keepPreviousData ?
            <div styleName="loading-wrapper">
              <Spinner block center />
            </div>
          : 
            projectId ? 
              <Row gutter={35}>
                <Col gutter={35}>
                  <div>
                    <Button type="weak" size="small" onClick={() => {
                      loadGallery();
                      browserHistory.push('/gallery');
                    }}>
                      <Icon name="arrow-left" /> {Translate.get('return_back')}
                    </Button>
                    <br /><br />
                  </div>
                  <H1><b>{gallery.project_name}</b></H1>
                </Col>
                {
                  gallery.media.items.map( (item, index) => (
                    <Col md="1/7" gutter={35} key={index}>
                      <Card styleName="gallery-item">
                        <small styleName="date">{moment(item.updated_at, 'YYYY-MM-DDTh:mm:ssZ').fromNow()}</small>
                        {
                          item.question_type === 'video_capture' ? 
                            <a
                              onClick={e => ::this.openLightbox(item.index, e)}
                              styleName="media-thumb"
                            >
                              <Icon name="play" />
                              <MediaPlayer url={item.link} controls={false} height="164px"/>
                            </a>
                          : 
                            <a onClick={e => ::this.openLightbox(item.index, e)}>
                              <Image
                                source={this.makeImageResizeURL(item.link, '150x150')}
                                cover
                                square
                                hideOnLoad
                              />
                            </a>
                        }
                      </Card>
                    </Col>
                  ))
                }
              </Row>
            : 
              typeof gallery !== "undefined" && gallery.length > 0 ? 
                gallery.map( (project, projectIndex) => (
                  <Row gutter={35} key={projectIndex}>
                    <Col gutter={35}>
                      <H1><b>{project.project_name}</b></H1>
                    </Col>
                    {
                      project.media.items.map( (item, index) => (
                        <Col md="1/7" gutter={35} key={index+' '+projectIndex}>
                          <Card styleName="gallery-item">
                            <small styleName="date">{moment(item.updated_at, 'YYYY-MM-DDTh:mm:ssZ').fromNow()}</small>
                            {
                              item.question_type === 'video_capture' ? 
                                <a
                                  onClick={e => ::this.openLightbox(item.index, e)}
                                  styleName="media-thumb"
                                >
                                  <Icon name="play" />
                                  <MediaPlayer url={item.link} controls={false} height="164px"/>
                                </a>
                              : 
                                <a onClick={e => ::this.openLightbox(item.index, e)}>
                                  <Image
                                    source={this.makeImageResizeURL(item.link, '150x150')}
                                    cover
                                    square
                                    hideOnLoad
                                  />
                                </a>
                            }
                          </Card>
                        </Col>
                      ))
                    }
                    {
                      project.media.count > 5 && project.media.items.length < 7 ?
                        <Col md="1/7" gutter={35}>
                          <div styleName="see-more-button-wrapper">
                            <Button styleName="see-more-button" onClick={() => loadProjectGallery(project.project_id)}>
                              {Translate.get('see_more')} <Icon name="arrow-right" />
                            </Button>
                          </div>
                        </Col>
                      : null
                    }
                  </Row>
                ))
              : <h1 style={{textAlign: 'center', fontWeight: '300', textTransform: 'uppercase', padding: '210px 0px'}}>{Translate.get('no_result')}</h1>
        }
        {
          typeof gallery !== "undefined" && !isFetching ? 
            <Row>
              <Lightbox
                images={this.state.images}
                currentImage={this.state.currentImage}
                isOpen={this.state.lightboxIsOpen}
                onClose={::this.closeLightbox}
                onClickNext={::this.gotoNext}
                onClickPrev={::this.gotoPrevious}
                onClickThumbnail={::this.gotoImage}
                backdropClosesModal={true}
                showThumbnails={true}
                zoom={true}
                content={true}
                customMedia={this.state.customMedia || null}
              >
                {this.renderCaption(this.state.currentImage)}
              </Lightbox>
            </Row>
          : ''
        }
        <div styleName="load-more-button">
          {
            isFetching && keepPreviousData ? 
              <Spinner block center />
            : 
              totalCount > (projectId ? gallery.media.items.length : gallery.length) ?
                <Button type="ghost" onClick={() => loadMore(Number(currentPage)+1)}>
                  {Translate.get('load_more')}
                </Button>
              : null
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/gallery/gallery.js